'use strict';

export const GET_WEEK_NAV = 'app/GET_WEEK_NAV';
export const GET_WEEK_NAV_COMPLETED = 'app/GET_WEEK_NAV_COMPLETED';
export const GET_DAY_NAV = 'app/GET_DAY_NAV';
export const GET_DAY_NAV_COMPLETED = 'app/GET_DAY_NAV_COMPLETED';
export const UPDATE_LOCATION = 'app/UPDATE_LOCATION';
export const UPDATE_CLIENT_WIDTH = 'app/UPDATE_CLIENT_WIDTH';
export const UPDATE_URL_PARAMS = 'app/UPDATE_URL_PARAMS';
export const SET_ACTION_MODE = 'app/SET_ACTION_MODE';
export const SET_PAGE = 'app/SET_PAGE';
export const SET_RESPONSIVE = 'app/SET_RESPONSIVE';
export const SET_PAGE_CONTEXT = 'app/SET_PAGE_CONTEXT';
export const SET_PAGE_LOADED = 'app/SET_PAGE_LOADED';
export const SET_PAGE_ID = 'app/SET_PAGE_ID';
export const SET_ROUTER_IN_PROGRESS = 'app/SET_ROUTER_IN_PROGRESS';
export const UNSET_ROUTER_IN_PROGRESS = 'app/UNSET_ROUTER_IN_PROGRESS';
export const SET_MODAL_OPEN = 'app/SET_MODAL_OPEN';
export const SET_MODAL_CLOSE = 'app/SET_MODAL_CLOSE';
export const SET_JOB = 'app/SET_JOB';
export const SET_MENU_OPEN = 'app/SET_MENU_OPEN';
export const SET_MENU_CLOSE = 'app/SET_MENU_CLOSE';
export const SET_USERS_LOADED = 'app/SET_USERS_LOADED';
